import { BASE_URL } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'GET_PTM_SLIDES',
  GET_SUCCESS: 'GET_PTM_SLIDES_SUCCESS',
  GET_FAILURE: 'GET_PTM_SLIDES_FAILURE',
  PATCH: 'PATCH_EXPIRE_PTM_SLOT',
  PATCH_SUCCESS: 'PATCH_EXPIRE_PTM_SLOT_SUCCESS',
  PATCH_FAILURE: 'PATCH_EXPIRE_PTM_SLOT_FAILURE',
};

export const get = actions.get(
  teacherClassroomId => `${BASE_URL}/ptm/ptm-classroom/${teacherClassroomId}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const patch = actions.patch(
  teacherClassroomId => `${BASE_URL}/ptm/ptm-classroom/${teacherClassroomId}`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);
